import http from "../utils/http";

export const getSearch = async (params: string): Promise<Response> => {
  return await http.get(`/api/search${params}`);
};
